/**
 * Redis Stream Error Types
 *
 * Client-safe error types for Redis stream operations.
 * Separated from RedisEventStream.ts to avoid pulling ioredis into client bundles.
 *
 * @since 1.0.0
 */

import { Schema } from "effect";

// Re-export the shared RedisStreamError from @fm/redis-stream
export { RedisStreamError } from "@fm/redis-stream/RedisStreamError";

/**
 * Redis event data schema for internal use
 * @since 1.0.0
 */
export const RedisEventDataSchema = Schema.Struct({
  eventId: Schema.optional(Schema.String),
  type: Schema.String,
  executionId: Schema.String,
  // Additional fields serialized as JSON
  data: Schema.optional(Schema.Unknown),
});

export type ResearchEventData = Schema.Schema.Type<typeof RedisEventDataSchema>;
